import { confirmSurveyAction } from "./confirmSurveyAction";

/**
 * Runs archive + resink. Returns true on success (caller should close the
 * dialog); false on failure (dialog stays open; onError has been called).
 *
 * Error copy lives on ApiSurveys archive options.error.
 */
export async function confirmArchiveSurvey(params: {
  archive: () => Promise<unknown>;
  resink: () => Promise<unknown>;
  onError: (message: string) => void;
}): Promise<boolean> {
  return confirmSurveyAction({
    run: params.archive,
    resink: params.resink,
    onError: params.onError,
    fallback: "Failed to archive survey",
  });
}

/**
 * Runs restore + resink. Returns true on success; false on failure
 * (onError has been called).
 */
export async function confirmRestoreSurvey(params: {
  restore: () => Promise<unknown>;
  resink: () => Promise<unknown>;
  onError: (message: string) => void;
}): Promise<boolean> {
  return confirmSurveyAction({
    run: params.restore,
    resink: params.resink,
    onError: params.onError,
    fallback: "Failed to restore survey",
  });
}
